<template>
	<v-card class="" style="padding:30px;">
		<b-o-input
			v-if="data.isAsko"
			v-model="currentTheme"
			:input="{ label: 'Theme', type: 'select', values: data.themes }"
		/>
		<sub-array-input
			:key="currentTheme"
			v-if="value[currentIndex]"
			label="Groupes"
			v-model="value[currentIndex].subBots"
			:items="subBotsInputs"
		></sub-array-input>
		<test-scheduler
			v-if="data && data.schedulerActivated"
			:scheduler="value[currentIndex]"
			:is-asko="data.isAsko"
			:botName="data.name"
			:subBots="subBots"
		/>
	</v-card>
</template>

<script>
import SubArrayInput from '../../baseComponents/inputs/subArrayInput'
import BOInput from '../../baseComponents/boInput'
import TestScheduler from './test.scheduler'

export default {
	props: ['value', 'data'],
	components: { BOInput, SubArrayInput, TestScheduler },
	data() {
		return {
			currentIndex: null,
			currentTheme: null,
		}
	},
	mounted() {
		this.init()
	},
	watch: {
		currentTheme() {
			this.init()
		},
		value() {
			this.init()
		},
		'data.isAsko'() {
			this.currentTheme = ''
			if (this.data.isAsko) {
				const shceduler =
					this.value && this.value.length > 0 ? this.value.find((scheduler) => !!scheduler.theme) : undefined
				if (shceduler) {
					this.currentTheme = shceduler.theme
				}

				if (!this.currentTheme && this.data.themes && this.data.themes.length > 0) {
					this.currentTheme = this.data.themes[0]
				}
			}
		},
	},
	methods: {
		init() {
			if (!this.currentTheme) {
				this.currentTheme = ''
				if (this.data.isAsko) {
					if (this.value && this.value.length > 0) {
						this.currentTheme = this.value[0].theme
					} else if (this.data.themes && this.data.themes.length > 0) {
						this.currentTheme = this.data.themes[0]
					}
				}
			}
			this.currentIndex = this.value.findIndex((scheduler) => scheduler.theme === this.currentTheme)
			if (this.currentIndex === -1) {
				this.$emit('input', [
					...(this.value && this.value.length > 0 ? this.value : []),
					{
						theme: this.currentTheme,
						subBots: [],
					},
				])
			}
		},
	},
	computed: {
		isCreation() {
			return !this.$route.params.botId
		},
		subBots() {
			return this.isCreation ? this.data.subBots : this.$store.getters.bot.subBots
		},
		subBotsInputs() {
			return [
				{
					label: 'Groupe',
					value: '_id',
					type: 'select',
					values: this.subBots,
					itemText: (subBot) => subBot.name,
					itemValue: this.isCreation ? (subBot) => subBot.name : (subBot) => subBot._id,
					required: true,
				},
				{
					label: 'Délai (mois)',
					value: 'monthDelay',
					type: 'number',
					rules: [(v) => (this.data && this.data.isAsko) || v >= 0 || '>= à 0'],
				},
				{
					label: 'Délai (semaines)',
					value: 'weekDelay',
					type: 'number',
					rules: [(v) => (this.data && this.data.isAsko) || v >= 0 || '>= à 0'],
				},
				{
					label: 'Délai (jours)',
					value: 'dayDelay',
					type: 'number',
					rules: [(v) => (this.data && this.data.isAsko) || v >= 0 || '>= à 0'],
				},
				{
					label: 'Heure',
					value: 'hour',
					type: 'select',
					itemText: 'text',
					itemValue: 'value',
					values: [
						'0',
						'1',
						'2',
						'3',
						'4',
						'5',
						'6',
						'7',
						'8',
						'9',
						'10',
						'11',
						'12',
						'13',
						'14',
						'15',
						'16',
						'17',
						'18',
						'19',
						'20',
						'21',
						'22',
						'23',
					].map((text) => ({ text, value: Number(text) })),
					hide: (value, bot) => {
						return !this.data.isAsko
					},
					rules: [(v) => v >= 0 || 'champs requis'],
				},
				{
					label: 'Minutes',
					value: 'minutes',
					type: 'select',
					itemText: 'text',
					itemValue: 'value',
					values: ['0', '15', '30', '45'].map((text) => ({ text, value: Number(text) })),
					hide: (value, bot) => {
						return !this.data.isAsko
					},
					rules: [(v) => v >= 0 || 'champs requis'],
				},
				{
					label: 'Filtre',
					value: 'filters',
					type: 'text',
					rules: [
						(v) =>
							!v ||
							v
								.trim()
								.split(';')
								.filter((filter) => filter !== '')
								.reduce(
									(valid, filter) =>
										valid &&
										filter
											.trim()
											.split(/!=|=/)
											.filter((filter) => filter !== '').length === 2,
									true,
								) ||
							"Format du filtre = 'key=value;key2!=value'",
					],
				},
			]
		},
	},
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/bots/scheduler.form.vue